angular.module("digitalLeasing.module").component("derogationsManage", {
    templateUrl: "ng/components/digitalLeasing/derogationsManage/derogationsManage.view.html",
    bindings: {
        model: "=",
        exportValidityDerogationsManage: "&",
        exportValueModal: "&",
        isMonitorPratiche: "<",
        navigatorInfo: '='
    },
    controllerAs: "derogationsManageCtrl",
    controller: function DerogationsManage($financialApiService) {
        var self = this;

        self.$onInit = function () {
            jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
            self.actionOk = "";
            self.deroghe = [];

            self.exportValidityNoteStatus(false);


            $financialApiService.poteriDeroga(self.model)
                .then(function (response) {
                    if (response.success) {
                        self.lblModalKo = response.lblModalKo;
                        self.lblModalOk = response.lblModalOk;
                        if (response.nextAssignerOk && response.nextAssignerOk.ragioneSociale) {
                            self.textValueOk = response.nextAssignerOk.ragioneSociale;
                        }
                        if (response.nextAssignerKo && response.nextAssignerKo.ragioneSociale) {
                            self.textValueKo = response.nextAssignerKo.ragioneSociale;
                        }
                        self.actionsLength = response.actions.length;
                        self.canEditPreventive = response.canEditPreventive;
                        self.model.leasingData.preventivo.dettaglioDeroga.dettaglioDerogaNSIL = response.deroghe;
                        self.actions = response.actions;
                        self.model.leasingData.preventivo.dettaglioDeroga.selectedNextStep = response.selectedNextStep;
                        self.nextStepList = response.nextStepList;
                        self.canApproveOnBehalf = response.canApproveOnBehalf;
                        self.canSkip = response.canSkip;
                        self.delegatingApprover = response.delegatingApprover;
                        self.canGoToCc = response.canGoToCc;
                        self.nextAssignerInfo = response.nextAssignerInfo
                        self.canEditAccountManager = response.canEditAccountManager;
                        self.accountManagerName = response.accountManagerName;

                        if (response.actions.includes('NEXT')) {
                            self.actionOk = 'NEXT';
                        }

                        if (response.actions.includes('APPROVE')) {
                            self.actionOk = 'APPROVE';
                        }

                        self.deroghe = response.deroghe;

                        self.deroghe.forEach(function (deroga) {
                            self.model.leasingData.preventivo.pianoFinanziario.spese.forEach(function (spesa) {
                                if (spesa.id === deroga.codiceTipoDeroga) {
                                    Object.assign(spesa, {
                                        codiceTipoDeroga: deroga.codiceTipoDeroga,
                                        up: deroga.up,
                                        userCanApprove: deroga.userCanApprove
                                    })
                                }
                            })
                        })

                        if (!self.actionsLength) {
                            self.exportValidityNoteStatus(false);
                        }
                    }
                })
                .catch(function (error) {
                    console.log("error", error);
                })
        }

        self.exportValidityNoteStatus = function (validity) {
            var validita = validity && !!self.actionsLength
            self.exportValidityDerogationsManage({
                validity: validita
            })
        }

        self.exportTxtValueModal = function (value) {
            if (self.model.leasingData.preventivo.dettaglioDeroga && self.model.leasingData.preventivo.dettaglioDeroga.selectedNextStep && self.model.leasingData.preventivo.dettaglioDeroga.selectedNextStep.description) {
                self.textValueOk = self.model.leasingData.preventivo.dettaglioDeroga.selectedNextStep.description
            }
            if (value == 'APPROVE') {
                self.exportValueModal({
                    label: 'LBL_DEROGA_APPROVED',
                    textValue: undefined,
                    actionSelected: value
                })
            } else if (value == 'NEXT') {
                self.exportValueModal({
                    label: self.lblModalOk,
                    textValue: self.textValueOk,
                    actionSelected: value
                })
            } else if (value == 'REQUEST_CORRECTION') {
                self.exportValueModal({
                    label: self.lblModalKo,
                    textValue: self.textValueKo,
                    actionSelected: value
                })
            } else if (value == 'CUSTOMER_CARE') {
                self.exportValueModal({
                    label: self.lblModalOk,
                    textValue: 'LBL_PRICING_OFFICE',
                    actionSelected: value
                })
            }
        }
    }
})